import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=257d36ff&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=257d36ff&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d36ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257d36ff')) {
      api.createRecord('257d36ff', component.options)
    } else {
      api.reload('257d36ff', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=257d36ff&scoped=true", function () {
      api.rerender('257d36ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/UserInfo.vue"
export default component.exports